<div class="flex flex-col justify-start items-center">
    <!--     <select *ngIf="cameras.length"
            [(ngModel)]="selected"
            (change)="switchCam(selected)">
      <option *ngFor="let c of cameras" [value]="c.deviceId">{{ c.label }}</option>
    </select> -->



    <div class="relative  camera-feed-container  bg-black">
        <div class="flex flex-col justify-start items-center gap-2 bg-black/90 text-white backdrop-blur-2xl rounded-b-3xl p-2 w-full absolute top-0 z-10"
            *ngIf="showSettings == true" @slideDownUp>

            <p>Impostazioni fotocamera</p>
            @if(cameras && selected.length > 0){

            <form [formGroup]="form">
                <mat-chip-listbox #chipList [formControlName]="'camera'" [value]="selected" multiple="false"
                    required="true">
                    <ng-container class="flex flex-wrap w-full">

                        @for (c of cameras; track c.deviceId) {
                        <mat-chip-option class="custom" [value]="c.deviceId"
                            (selectionChange)="switchCam($event, c.deviceId)">{{ c.label
                            }}</mat-chip-option>
                        }
                    </ng-container>
                </mat-chip-listbox>

                <div class="flex justify-between items-center gap-2 text-xs">

                    <mat-slide-toggle name="frame" [checked]="showFrame" (change)="changeFrameVisibility($event)">Mostra
                        riquadro</mat-slide-toggle>
                    <!-- <mat-slide-toggle name="ocrType" [checked]="ocrType" (change)="changeOcrType($event)">OCR
                        avanzato</mat-slide-toggle> -->
                </div>

            </form>

            }@else{
            <div class="p-2 bg-red-800 rounded-xl text-white">
                Impossibile accedere alle fotocamere del dispositivo, controlla i permessi e riprova.
            </div>
            }

            <p *ngIf="showFreezeHint" class="warn">
                Errore durante il caricamento della fotocamera
                <button (click)="retry()">Ricarica</button>
            </p>
        </div>
        <div (click)="showSettings = !showSettings" class="absolute top-0 right-0 rounded-full text-white p-2 z-10">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5 ">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path
                    d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z" />
                <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
            </svg>
        </div>

        <div (click)="retry()" class="absolute top-0 left-0 rounded-full text-white p-2 z-10">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="w-5 h-5">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M19.933 13.041a8 8 0 1 1 -9.925 -8.788c3.899 -1 7.935 1.007 9.425 4.747" />
                <path d="M20 4v5h-5" />
            </svg>
        </div>

        <div
            class="flex flex-col justify-center items-center  absolute top-0 z-20 {{ cameraError ? '' : 'hidden'}}  w-full h-full">
            <div class="p-2 rounded-full backdrop-blur-xl text-white w-12 h-12">

                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-full h-full">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path
                        d="M13.5 20h-8.5a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v4" />
                    <path d="M9 13a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
                    <path d="M22 22l-5 -5" />
                    <path d="M17 22l5 -5" />
                </svg>

            </div>
        </div>


        <div *ngIf="cameraLoading" @fadeInOutWithBlur
            class="flex flex-col justify-center items-center  absolute top-0 z-5 bg-white/20 backdrop-blur-xl  w-full"
            style="aspect-ratio: 3/4;width: 100vw;">
            <div class="p-2 rounded-full backdrop-blur-xl animate-pulse text-white w-12 h-12">

                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-full h-full">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path
                        d="M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2" />
                    <path d="M9 13a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
                </svg>

            </div>
        </div>



        <div class="relative inline-block z-5">
            <video #videoEl class=" object-cover" playsinline webkit-playsinline>
            </video>
            <div #cropBox
                class="absolute border-2 transition-all duration-300 border-white mix-blend-difference pointer-events-none {{showFrame && !cameraLoading ? 'opacity-100' : 'opacity-0'}}"
                [ngStyle]="{
                width: cropWidth + '%',
                height: cropHeight + '%',
                left: (100 - cropWidth) / 2 + '%',
                top: (100 - cropHeight) / 2 + '%'
            }"></div>
        </div>


        <!-- <div
            class="flex flex-col justify-center items-center  absolute top-0 z-20   w-full h-full">
            <div class="p-2 rounded-full backdrop-blur-xl animate-spin text-white w-12 h-12">

                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-full h-full">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4" />
                    <path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4" />
                </svg>

            </div>
        </div> -->

        <!-- <canvas #canvasElement class=" w-full  absolute top-0  z-10 {{ processing ? '' : 'hidden'}}"></canvas> -->

    </div>


    <button *ngIf="!cameraError && !cameraLoading" (click)="captureFrame()" @fadeInOutWithBlur
        class="sticky bottom-4 bg-white text-black camera-button white rounded-full p-2">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round" class="w-10 h-10 ">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path
                d="M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2" />
            <path d="M9 13a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
        </svg>
    </button>

    <div *ngIf="cameraError" class="sticky bottom-4 bg-white camera-button white rounded-full p-2">
        Consenti l'accesso alla fotocamera per continuare
    </div>



</div>